var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box",class:{ selected: _vm.value },on:{"click":function($event){return _vm.$emit('input', !_vm.value)}}},[_c('v-icon',[_vm._v(_vm._s(_vm.value ? "lens" : "panorama_fish_eye"))]),_vm._v("\n  "+_vm._s(_vm.label)+"\n")],1)}
var staticRenderFns = []

export { render, staticRenderFns }